import React from 'react';
import Header from '../components/Header';
import BookRide from '../components/BookRide';
import Footer from '../components/Footer';
import './Investor.css';

const pub = process.env.PUBLIC_URL;

const investTypes = [
  {
    img: 'regular-investing.webp',
    title: 'Equity Partnership',
    text: 'Be part of a transformative industry and support our growth and innovation with a standard equity investment.',
  },
  {
    img: 'dealership.webp',
    title: 'Dealership',
    text: 'Become part of our exclusive dealership network under the COCO model. Acriolis handles operations while you benefit from a robust, scalable business model.',
  },
  {
    img: 'atv-circuit.webp',
    title: 'Off-Road Circuit Investment',
    text: 'Tap Into the Growing Adventure Tourism Market — Invest in our exclusive Off-Road racing circuits, combining adrenaline, innovation, and profits.',
  },
];

const stats = [
  { img: '1-1.webp', label: 'Market Size', value: '$29.23 billion by 2030*' },
  { img: '5-1.webp', label: 'CAGR', value: '7.3% from 2022 to 2031*' },
  { img: '7.webp', label: 'Market Value', value: '$18.6 billion by 2031*' },
];

function Investor() {
  return (
    <div>
      <Header />

      {/* ── Hero ── */}
      <section
        className="inv-hero"
        style={{ backgroundImage: `url(${pub}/investor/background-Investment.webp)` }}
      >
        <div className="inv-hero__overlay" />
        <div className="inv-hero__content">
          <h1 className="inv-hero__heading">
            Invest in the Future: Explore Opportunities
            with Acriolis India Motors
          </h1>
          <p className="inv-hero__text">
            As pioneers in the All-Terrain Vehicle (ATV) and Utility Task Vehicle (UTV)
            industry, we invite you to join us in driving the future of off-road mobility.
            Explore our unique investment opportunities tailored for visionary partners like
            you. Together, we'll shape the future of mobility and adventure.
          </p>
        </div>
      </section>

      {/* ── Fuel the future ── */}
      <section className="inv-fuel">
        <span className="inv-fuel__eyebrow">FUEL THE FUTURE.</span>
        <h2 className="inv-fuel__heading">
          Join us to revolutionise adventure off-roading.
        </h2>
        <p className="inv-fuel__sub">
          Experience our patented off-road design that pushes boundaries with advanced
          technology, peak performance, and real-time monitoring. Pick your investment
          type and join the ride!
        </p>

        <div className="inv-fuel__grid">
          {investTypes.map((t) => (
            <div className="inv-fuel__card" key={t.title}>
              <div
                className="inv-fuel__card-img"
                style={{ backgroundImage: `url(${pub}/investor/${t.img})` }}
              />
              <div className="inv-fuel__card-body">
                <h3 className="inv-fuel__card-title">{t.title}</h3>
                <p className="inv-fuel__card-text">{t.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── Live The Thrill ── */}
      <section className="inv-thrill">
        <h2 className="inv-thrill__heading">Live The Thrill.</h2>
        <p className="inv-thrill__text">
          Experience the ultimate off-road thrill with Off-Road Circuit by Acriolis Motors
          India — adrenaline adventure on rugged terrains awaits!
        </p>
      </section>

      {/* ── More than investors ── */}
      <section
        className="inv-partner"
        style={{ backgroundImage: `url(${pub}/Rectangle-4925.webp)` }}
      >
        <div className="inv-partner__overlay" />
        <div className="inv-partner__content">
          <span className="inv-partner__eyebrow">DRIVING INNOVATION</span>
          <h2 className="inv-partner__heading">We want more than just investors</h2>
          <p className="inv-partner__text">
            Partner with ACRIOLIS India Motors — As an emerging player in off-road vehicle
            innovation with over a decade of experience, we offer exciting opportunities in
            equity investment, the COCO model, and the Off-Road racing circuit. Join us in
            driving the future of mobility!
          </p>
        </div>
      </section>

      {/* ── Stats ── */}
      <section className="inv-stats">
        <h2 className="inv-stats__heading">All the numbers game</h2>
        <p className="inv-stats__sub">
          Explore the stats behind our growth, innovation, and market impact — proof of our
          excellence and customer satisfaction in every ride!
        </p>
        <div className="inv-stats__grid">
          {stats.map((s) => (
            <div
              className="inv-stats__card"
              key={s.label}
              style={{ backgroundImage: `url(${pub}/investor/${s.img})` }}
            >
              <div className="inv-stats__card-overlay" />
              <div className="inv-stats__card-content">
                <span className="inv-stats__label">{s.label}</span>
                <span className="inv-stats__value">{s.value}</span>
              </div>
            </div>
          ))}
        </div>
        <p className="inv-stats__note">*As per various market reports available online.</p>
      </section>

      <BookRide />
      <Footer />
    </div>
  );
}

export default Investor;
